import React, { useState } from "react";
import { Button, Typography, Modal, Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";

const SaveAndSyncModal = (props) => {
    const { isOpen, toggleModal, handleSubmit } = props;

    const [syncChangesCheckbox, toggleSyncChangesCheckbox] = useState(false);

    const toggleModalClose = () => {
        toggleModal(false);
    };

    const toggleSyncChanges = () => {
        toggleSyncChangesCheckbox(!syncChangesCheckbox);
    };

    return (
        <Modal
            aria-labelledby="save-and-sync-modal"
            aria-describedby="saves information of property and syncs to all pertaining linked properties"
            open={isOpen}
            onClose={toggleModalClose}
        >
            <PaperDiv>
                <ModalHeader variant="h5">
                    Sync Changes?
                </ModalHeader>
                <FormContainer>
                    <p>
                        This Asset Service record shares the same Accounting System Software ID with other properties.
                    </p>
                    <SyncContainer onClick={toggleSyncChanges}>
                        <SyncCheckbox
                            color="primary"
                            checked={syncChangesCheckbox}
                        />
                        <SyncDesc>Check to apply changes to all linked properties.</SyncDesc>
                    </SyncContainer>
                    <SubmitButtons
                        toggleModalClose={toggleModalClose}
                        handleSubmit={() => handleSubmit(syncChangesCheckbox)}
                    />
                </FormContainer>
            </PaperDiv>
        </Modal>
    );
};

const SubmitButtons = (props) => {
    const { toggleModalClose, handleSubmit } = props;
    const closeModal = () => {
        toggleModalClose();
    };
    return (
        <SubmitButtonsContainer>
            <Button variant="contained" color="default" onClick={closeModal}>
                Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
                Save
            </Button>
        </SubmitButtonsContainer>
    );
};

const PaperDiv = styled('div')({
    display: "flex",
    flexDirection: "column",
    background: "white",
    top: "50%",
    left: "50%",
    width: "500px",
    height: "250px",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    alignItems: "center",
    borderRadius: "3px",
    boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
});

const ModalHeader = styled(Typography)({
    alignSelf: "center",
    marginTop: "5%",
});

const FormContainer = styled('div')({
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    width: "80%",
    height: "90%",
});

const SubmitButtonsContainer = styled('div')({
    display: "flex",
    flexDirection: "row",
    alignSelf: "end",
    paddingBottom: "15px",
});

const SyncCheckbox = styled(Checkbox)({
    padding: 0,
    paddingRight: "15px",
});

const SyncDesc = styled('span')({
    cursor: "pointer",
});

const SyncContainer = styled('span')({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
});


export default SaveAndSyncModal;
